import styled from 'styled-components';
import { ReactComponent as RawFullscreenExitSVG } from '../../../../assets/icons/icon_fullscreen_exit.svg';

export const IconFullscreenExit = styled(RawFullscreenExitSVG)``;
